module.exports = __webpack_public_path__ + "img/fsg_lacrosse.755b862f.svg";